import {Component, Input, Output, SimpleChanges, EventEmitter, ViewChild, ElementRef, forwardRef} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import {SeleccionarDiponiblePipe} from '../../Pipes/SeleccionarDiponible.pipe';
import {SistemaService} from '../../Servicios/Sistema.Service';
import {TranslateService} from '@ngx-translate/core';

declare var $: any;
declare function Focus(id : string) : any;

const noop = () =>
{
};

export const CUSTOM_TEXTAREA_CONTROL_VALUE_ACCESSOR: any =
  {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TextareaComponent),
    multi: true
  };

@Component(
  {
    selector: 'textareaCustom',
    templateUrl: './Textarea.template.html',
    styleUrls: ['./Textarea.scss'],
    providers: [CUSTOM_TEXTAREA_CONTROL_VALUE_ACCESSOR]
  })

export class TextareaComponent implements ControlValueAccessor
{
  public innerValue : string = "";

  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  @Input() titulo : string = ""; // titulo del input

  @Input() sinMargen : boolean = false; // control deshabilitado
  @Input() disabled : boolean = false; // control deshabilitado
  @Input() verError : boolean = true; // indica si el error esta habilitado para mostrarse
  @Input() errorActivo : boolean = false; // indica si el error esta habilitado para mostrarse
  @Input() mensajeError : string = ""; // indica el mensaje de error a mostrar
  @Input() placeholder : string = ""; // indica el mensaje de error a mostrar
  @Input() maxLength : number = 9999; // indica la longitud maxima del input
  @Input() uppercase : boolean = false; // indica si el input esta en mayusculas
  @Input() modelValue: string = "";
  @Output() event = new EventEmitter();


  public id : number = 0;
  public placeholderText: string = "";
  public updatedErrorValue = null;

  constructor(public sistemaService : SistemaService, public translate : TranslateService)
  {
    this.sistemaService.numeroControl++;
    this.id = this.sistemaService.numeroControl;

  }

  ngOnInit()
  {
  }

  Focus()
  {
  }

  internalEventHandler = (dataToOutput: any) => this.event.emit(dataToOutput);

  // control ngModel
  get valor(): any
  {
    return this.innerValue;
  };

  //set accessor including call the onchange callback
  set valor(nuevoValor: any)
  {
    if (nuevoValor !== this.innerValue)
    {
      this.innerValue = nuevoValor;
      this.onChangeCallback(nuevoValor);
    }
  }

  writeValue(valor: any)
  {
    if (valor !== this.innerValue)
    {
      this.innerValue = valor;
    }
  }

  registerOnChange(fn: any)
  {
    this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  registerOnTouched(fn: any)
  {
    this.onTouchedCallback = fn;
  }
}
